// extracted by mini-css-extract-plugin
export default {"boxBackground":"Assessments_boxBackground__JtQ0O","dateBoxBackground":"Assessments_dateBoxBackground__y9Xu3"};